import { IItemForGetShortInfo, ITotalPrice } from 'types';
import React, { useCallback, useMemo } from 'react';
import MultipleSelect from './components/MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './IsRestrictedField.module.scss';

interface IIsRestrictedField {
	setRestrictedInRestaurants: (value: string[]) => void;
	isRestrictedInRestaurants: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
	totalPrices: ITotalPrice[];
}

const IsRestrictedField: React.FC<IIsRestrictedField> = ({
	isRestrictedInRestaurants,
	fetchedRestaurants,
	setRestrictedInRestaurants,
	totalPrices,
}) => {
	const handleRemove = useCallback(
		(id: string) => {
			const selectedItems = isRestrictedInRestaurants.filter((el) => el !== id);
			setRestrictedInRestaurants(selectedItems);
		},
		[isRestrictedInRestaurants, setRestrictedInRestaurants],
	);

	const restaurantsList = useMemo(() => {
		return isRestrictedInRestaurants.map((el) => {
			const label = fetchedRestaurants.find((rest) => rest.id === el)?.name || '';
			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [isRestrictedInRestaurants, fetchedRestaurants, handleRemove]);

	return (
		<div className={style.container} data-test="IsRestrictedField">
			<div className={style.field}>
				<MultipleSelect
					totalPrices={totalPrices}
					isRestrictedInRestaurants={isRestrictedInRestaurants}
					setRestrictedInRestaurants={setRestrictedInRestaurants}
				/>
			</div>
			<div className={style.restaurantsList}>{restaurantsList}</div>
		</div>
	);
};

export default React.memo(IsRestrictedField);
